/**
 * Rich Text Editor 6001 — BDU auxiliary page body.
 *
 * The article plus an optional lead form rail. The form itself (variant, copy,
 * courses, qualifications) comes from University Settings → Lead Drop Form, so
 * the only control here is the toggle that opts this section into showing it.
 */

export const RICH_TEXT_EDITOR_6001_CONSTANTS = {
  DEFAULT_ROW: {
    id: "",
    content: "",
    background_color: "#FFFFFF",
    enable_lead_form: false,
    status: false,
  },

  RICH_TEXT_EDITOR_FIELDS_CONFIG: [
    {
      fieldName: "content",
      label: "Content",
      value: "",
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      placeholder: "Enter content",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "background_color",
      label: "Background color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "enable_lead_form",
      label: "Show lead form",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show the site's lead form beside the content",
      description:
        "Renders the Lead Drop Form configured in University Settings in a 328px rail (desktop only). With no form configured there, the content takes the full width.",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "status",
      label: "Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable section",
      required: false,
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [],
};
